import { Injectable } from '@angular/core';
import {API_URL} from '../shared/constants/apiurl-constants';
import {SessionService} from '../shared/session-service/session.service';
import { Observable } from 'rxjs';
import { GetSmesEmailSentDetailsBySurveyIdsDto } from 'src/app/shared/models/get-smes-email-sent-details-by-survey-ids-dto';
import { SurveyMetrics } from '../survey/models/survey-metrics.model';

@Injectable({
  providedIn: 'root'
})
export class SurveyInsightService {
  engagementNumber: string;
  _surveyMetrics: SurveyMetrics
  constructor(public sessionService: SessionService) { }

  public get surveyMetrics(): SurveyMetrics {
    return this._surveyMetrics;
  }
  public set surveyMetrics(value: SurveyMetrics) {
    this._surveyMetrics = value;
  }

      public getEngagementById(engagementId: any, updateRecentlyViewedEngagement: boolean = false): Observable<any>  {
        let id: any;
    
        if (engagementId > 0) {
          id = engagementId.toString();
        } else {
          id = this.sessionService.getSession('engagementId');
        }
      return  this.sessionService
          .apiUrlGet(API_URL.ENGAGEMENT.GETENGAGEMENTBYID + '?engagementId=' + id +
          '&updateRecentlyViewedEngagement=' + updateRecentlyViewedEngagement,
        );
    }

  getStudySummary(engagementId){
    return this.sessionService.apiUrlGet(
      API_URL.GET_STUDY_SUMMARY + '?engagementId=' + engagementId,
    );
  }

  getEngagementQRE(engagementId) {
    return this.sessionService.apiUrlGet(
        API_URL.INSIGHTSGETQRE + '?engagementId=' + engagementId
    );
  }

  getSmesEmailSentDetailsBySurveyIds(getDetailsDto: GetSmesEmailSentDetailsBySurveyIdsDto) {
    return this.sessionService.apiUrlPost(API_URL.SURVEY.GET_SME_EMAIL_SENT_BY_SURVEY_IDS, getDetailsDto);
  }

  getSMEsEmailSentDateDetails(surveyId: number, engagementId: number) {
    return this.sessionService.apiUrlGet(API_URL.SURVEY.GET_SME_EMAIL_SENT_DETAILS + `?surveyId=${surveyId}&engagementId=${engagementId}`);
  }
}
